import { Routes } from '@dtx-company/true-common/src/constants/routes'
import {
  TOP_NAV_BANNER_HEIGHT,
  TOP_NAV_BANNER_HEIGHT_MOBILE
} from '../TopNavBannerWrapper/TopNavBannerWrapper'
import { useMemo } from 'react'
import { matchesAnyRoute } from '@dtx-company/true-common/src/utils/urls/matchesRoute'
import { usePathname } from 'next/navigation'
import { useScreenSizeBreakpoints } from '@dtx-company/app/shared/common/src/hooks/useScreenSizeBreakpoints'
import { useTrialConfig } from '@dtx-company/app/shared/common/src/hooks/useTrialConfig/useTrialConfig'

export const useTrialBannerState = (): { displayTrialBanner: boolean; bannerHeight: number } => {
  const pathname = usePathname() ?? ''
  const trialConfig = useTrialConfig()
  const { isMobile } = useScreenSizeBreakpoints()
  const bannerHeight = isMobile ? TOP_NAV_BANNER_HEIGHT_MOBILE : TOP_NAV_BANNER_HEIGHT
  const displayTrialBanner = useMemo(() => {
    const routeBlockList = [
      Routes.SIGN_IN,
      Routes.SIGN_UP,
      Routes.FREE_QR_CODE_GENERATOR,
      Routes.BUY_PLAN_PAGE,
      Routes.ACCEPT_INVITE,
      Routes.ACCEPT_ORG_INVITE,
      Routes.VALIDATE_PRIVACY_REQUEST,
      Routes.NOT_FOUND
    ]
    const routeIsBlocked = matchesAnyRoute(pathname, routeBlockList)
    return !routeIsBlocked && Boolean(trialConfig?.inTrial)
  }, [trialConfig?.inTrial, pathname])

  return {
    displayTrialBanner,
    bannerHeight
  }
}
